module.exports = __webpack_public_path__ + "yandex_kassa_yandex_dengi.438997e88134aed1420f1dd9527c31fb.png";